<script setup lang="ts">
import {computed } from "vue";
// import ConversionClubLogo from "@/views/pages/main/ConversionClubLogo.vue";
import ConversionClubLogoMasked from "@/views/pages/main/ConversionClubLogoMasked.vue";
const props = defineProps({
  logoColor: {
    type: String,
    default: '#ffffff'
  },
  year: {
    type: Number || String,
    default: 2023
  }
})

const logoColor = computed(() => props.logoColor ? props.logoColor : '#ffffff')
const year = computed(() => props.year ? props.year : 2023)
</script>

<template>
  <a class="bps-banner"
     target="_blank"
     href="https://www.conversion-club.com/resultats-of-affiliate-space-awards-2023-bangkok-by-conversion-club">
    <div class="bps-banner--logo-cc">
      <ConversionClubLogoMasked :height="38" color="#fff" :mask-color="logoColor" />
<!--      <img src="./header/conversion-club-logo.svg" alt="" height="38" width="60" />-->
    </div>
    <div class="bps-banner--desc">
      <span class="title">
        <span class="title--header">{{$t('Лучшая онлайн платежная система')}}</span>
        <i18n tag="span" class="title--year" path="of the year {year}">
            <template #year>{{ year }}</template>
        </i18n>
      </span>
    </div>
  </a>
</template>

<style scoped lang="less">
@import "bps-banner";
</style>

<i18n>
{
  "ru": {
    "of the year {year}": "{year}"
  },
  "en": {
    "of the year {year}": "of the Year {year}",
    "Лучшая онлайн платежная система": "Best Online Payment Solution",
    "Лучшая онлайн платежная система 2023": "Online Payment Solution of the Year 2023",
    "Лучший платежный сервис 2023": "Best Payment Solution of the Year 2023",
    "Лучший платежный сервис 2022": "Best Payment Solution of the Year 2022"
  }
}
</i18n>
